import React, { FC } from 'react'
import './index.scss'

// interface
interface IProps {
  data: any[];
  value: any;
  onChange: (val: any) => void;
}

const Tabs: FC<IProps> = (props: IProps) => {
  const { value, data, onChange } = props
  return (
    <div className='tabs-bar-box'>
      {
        data.map((item: any) => (
          <div
            key={item.value}
            className={`bar-item ${item.value === value ? 'checked' : ''}`}
            data-cypid={`barItem_${item.value}`}
            onClick={() => onChange(item.value)}
          >
            {item.label}
          </div>
        ))
      }
    </div>
  )
}

export default Tabs
